import { createTRPCReact } from '@trpc/react-query';
import { httpBatchLink, loggerLink } from '@trpc/client';
import superjson from 'superjson';
import type { AppRouter } from '../../../server/routers';

export const trpc = createTRPCReact<AppRouter>();

function getApiUrl() {
  // Must be like https://api.joyaproperties.com (from env)
  const url = (import.meta as any).env?.VITE_API_URL || '';
  return url.replace(/\/$/, '');
}

export function createTrpcClient() {
  const base = getApiUrl();
  return trpc.createClient({
    transformer: superjson,
    links: [
      loggerLink({ 
        enabled: (op) => 
          process.env.NODE_ENV === 'development' || 
          (op.direction === 'down' && op.result instanceof Error) 
      }),
      httpBatchLink({
        url: `${base}/api/trpc`,
        fetch(url, opts) {
          return fetch(url, { ...opts, credentials: 'include' });
        },
      })
    ]
  });
}
